type CountriesMap = {
    [key: string]: any;
};
export type TBarType = "1" | "2" | "3" | "4";
export type IntegrationsType = "1" | "2";

export const countries: CountriesMap = {
    AC: "Ascension Island",
    AD: "Andorra",
    AE: "United Arab Emirates",
    AF: "Afghanistan",
    AG: "Antigua & Barbuda",
    AI: "Anguilla",
    AL: "Albania",
    AM: "Armenia",
    AN: "Netherlands Antilles",
    AO: "Angola",
    AR: "Argentina",
    AT: "Austria",
    AU: "Australia",
    AW: "Aruba",
    AX: "Åland Islands",
    AZ: "Azerbaijan",
    BA: "Bosnia & Herzegovina",
    BB: "Barbados",
    BD: "Bangladesh",
    BE: "Belgium",
    BF: "Burkina Faso",
    BG: "Bulgaria",
    BH: "Bahrain",
    BI: "Burundi",
    BJ: "Benin",
    BL: "St. Barthélemy",
    BM: "Bermuda",
    BN: "Brunei",
    BO: "Bolivia",
    BQ: "Caribbean Netherlands",
    BR: "Brazil",
    BS: "Bahamas",
    BT: "Bhutan",
    BV: "Bouvet Island",
    BW: "Botswana",
    BY: "Belarus",
    BZ: "Belize",
    CA: "Canada",
    CC: "Cocos (Keeling) Islands",
    CD: "Congo - Kinshasa",
    CF: "Central African Republic",
    CG: "Congo - Brazzaville",
    CH: "Switzerland",
    CI: "Côte d’Ivoire",
    CK: "Cook Islands",
    CL: "Chile",
    CM: "Cameroon",
    CN: "China",
    CO: "Colombia",
    CR: "Costa Rica",
    CU: "Cuba",
    CV: "Cape Verde",
    CW: "Curaçao",
    CX: "Christmas Island",
    CY: "Cyprus",
    CZ: "Czechia",
    DE: "Germany",
    DJ: "Djibouti",
    DK: "Denmark",
    DM: "Dominica",
    DO: "Dominican Republic",
    DZ: "Algeria",
    EC: "Ecuador",
    EE: "Estonia",
    EG: "Egypt",
    EH: "Western Sahara",
    ER: "Eritrea",
    ES: "Spain",
    ET: "Ethiopia",
    FI: "Finland",
    FJ: "Fiji",
    FK: "Falkland Islands",
    FO: "Faroe Islands",
    FR: "France",
    GA: "Gabon",
    GB: "United Kingdom",
    GD: "Grenada",
    GE: "Georgia",
    GF: "French Guiana",
    GG: "Guernsey",
    GH: "Ghana",
    GI: "Gibraltar",
    GL: "Greenland",
    GM: "Gambia",
    GN: "Guinea",
    GP: "Guadeloupe",
    GQ: "Equatorial Guinea",
    GR: "Greece",
    GS: "South Georgia & South Sandwich Islands",
    GT: "Guatemala",
    GW: "Guinea-Bissau",
    GY: "Guyana",
    HK: "Hong Kong SAR",
    HM: "Heard & McDonald Islands",
    HN: "Honduras",
    HR: "Croatia",
    HT: "Haiti",
    HU: "Hungary",
    ID: "Indonesia",
    IE: "Ireland",
    IL: "Israel",
    IM: "Isle of Man",
    IN: "India",
    IO: "British Indian Ocean Territory",
    IQ: "Iraq",
    IR: "Iran",
    IS: "Iceland",
    IT: "Italy",
    JE: "Jersey",
    JM: "Jamaica",
    JO: "Jordan",
    JP: "Japan",
    KE: "Kenya",
    KG: "Kyrgyzstan",
    KH: "Cambodia",
    KI: "Kiribati",
    KM: "Comoros",
    KN: "St. Kitts & Nevis",
    KP: "North Korea",
    KR: "South Korea",
    KW: "Kuwait",
    KY: "Cayman Islands",
    KZ: "Kazakhstan",
    LA: "Laos",
    LB: "Lebanon",
    LC: "St. Lucia",
    LI: "Liechtenstein",
    LK: "Sri Lanka",
    LR: "Liberia",
    LS: "Lesotho",
    LT: "Lithuania",
    LU: "Luxembourg",
    LV: "Latvia",
    LY: "Libya",
    MA: "Morocco",
    MC: "Monaco",
    MD: "Moldova",
    ME: "Montenegro",
    MF: "St. Martin",
    MG: "Madagascar",
    MK: "North Macedonia",
    ML: "Mali",
    MM: "Myanmar (Burma)",
    MN: "Mongolia",
    MO: "Macao SAR",
    MQ: "Martinique",
    MR: "Mauritania",
    MS: "Montserrat",
    MT: "Malta",
    MU: "Mauritius",
    MV: "Maldives",
    MW: "Malawi",
    MX: "Mexico",
    MY: "Malaysia",
    MZ: "Mozambique",
    NA: "Namibia",
    NC: "New Caledonia",
    NE: "Niger",
    NF: "Norfolk Island",
    NG: "Nigeria",
    NI: "Nicaragua",
    NL: "Netherlands",
    NO: "Norway",
    NP: "Nepal",
    NR: "Nauru",
    NU: "Niue",
    NZ: "New Zealand",
    OM: "Oman",
    PA: "Panama",
    PE: "Peru",
    PF: "French Polynesia",
    PG: "Papua New Guinea",
    PH: "Philippines",
    PK: "Pakistan",
    PL: "Poland",
    PM: "St. Pierre & Miquelon",
    PN: "Pitcairn Islands",
    PS: "Palestinian Territories",
    PT: "Portugal",
    PY: "Paraguay",
    QA: "Qatar",
    RE: "Réunion",
    RO: "Romania",
    RS: "Serbia",
    RU: "Russia",
    RW: "Rwanda",
    SA: "Saudi Arabia",
    SB: "Solomon Islands",
    SC: "Seychelles",
    SD: "Sudan",
    SE: "Sweden",
    SG: "Singapore",
    SH: "St. Helena",
    SI: "Slovenia",
    SJ: "Svalbard & Jan Mayen",
    SK: "Slovakia",
    SL: "Sierra Leone",
    SM: "San Marino",
    SN: "Senegal",
    SO: "Somalia",
    SR: "Suriname",
    SS: "South Sudan",
    ST: "São Tomé & Príncipe",
    SV: "El Salvador",
    SX: "Sint Maarten",
    SY: "Syria",
    SZ: "Eswatini",
    TA: "Tristan da Cunha",
    TC: "Turks & Caicos Islands",
    TD: "Chad",
    TF: "French Southern Territories",
    TG: "Togo",
    TH: "Thailand",
    TJ: "Tajikistan",
    TK: "Tokelau",
    TL: "Timor-Leste",
    TM: "Turkmenistan",
    TN: "Tunisia",
    TO: "Tonga",
    TR: "Türkiye",
    TT: "Trinidad & Tobago",
    TV: "Tuvalu",
    TW: "Taiwan",
    TZ: "Tanzania",
    UA: "Ukraine",
    UG: "Uganda",
    UM: "U.S. Outlying Islands",
    US: "United States",
    UY: "Uruguay",
    UZ: "Uzbekistan",
    VA: "Vatican City",
    VC: "St. Vincent & Grenadines",
    VE: "Venezuela",
    VG: "British Virgin Islands",
    VN: "Vietnam",
    VU: "Vanuatu",
    WF: "Wallis & Futuna",
    WS: "Samoa",
    XK: "Kosovo",
    YE: "Yemen",
    YT: "Mayotte",
    ZA: "South Africa",
    ZM: "Zambia",
    ZW: "Zimbabwe",
    ZZ: "Unknown Region",
};

export const countryArray = [
    { symbol: "AC", name: "Ascension Island" },
    { symbol: "AD", name: "Andorra" },
    { symbol: "AE", name: "United Arab Emirates" },
    { symbol: "AF", name: "Afghanistan" },
    { symbol: "AG", name: "Antigua & Barbuda" },
    { symbol: "AI", name: "Anguilla" },
    { symbol: "AL", name: "Albania" },
    { symbol: "AM", name: "Armenia" },
    { symbol: "AN", name: "Netherlands Antilles" },
    { symbol: "AO", name: "Angola" },
    { symbol: "AR", name: "Argentina" },
    { symbol: "AT", name: "Austria" },
    { symbol: "AU", name: "Australia" },
    { symbol: "AW", name: "Aruba" },
    { symbol: "AX", name: "Åland Islands" },
    { symbol: "AZ", name: "Azerbaijan" },
    { symbol: "BA", name: "Bosnia & Herzegovina" },
    { symbol: "BB", name: "Barbados" },
    { symbol: "BD", name: "Bangladesh" },
    { symbol: "BE", name: "Belgium" },
    { symbol: "BF", name: "Burkina Faso" },
    { symbol: "BG", name: "Bulgaria" },
    { symbol: "BH", name: "Bahrain" },
    { symbol: "BI", name: "Burundi" },
    { symbol: "BJ", name: "Benin" },
    { symbol: "BL", name: "St. Barthélemy" },
    { symbol: "BM", name: "Bermuda" },
    { symbol: "BN", name: "Brunei" },
    { symbol: "BO", name: "Bolivia" },
    { symbol: "BQ", name: "Caribbean Netherlands" },
    { symbol: "BR", name: "Brazil" },
    { symbol: "BS", name: "Bahamas" },
    { symbol: "BT", name: "Bhutan" },
    { symbol: "BV", name: "Bouvet Island" },
    { symbol: "BW", name: "Botswana" },
    { symbol: "BY", name: "Belarus" },
    { symbol: "BZ", name: "Belize" },
    { symbol: "CA", name: "Canada" },
    { symbol: "CC", name: "Cocos (Keeling) Islands" },
    { symbol: "CD", name: "Congo - Kinshasa" },
    { symbol: "CF", name: "Central African Republic" },
    { symbol: "CG", name: "Congo - Brazzaville" },
    { symbol: "CH", name: "Switzerland" },
    { symbol: "CI", name: "Côte d’Ivoire" },
    { symbol: "CK", name: "Cook Islands" },
    { symbol: "CL", name: "Chile" },
    { symbol: "CM", name: "Cameroon" },
    { symbol: "CN", name: "China" },
    { symbol: "CO", name: "Colombia" },
    { symbol: "CR", name: "Costa Rica" },
    { symbol: "CU", name: "Cuba" },
    { symbol: "CV", name: "Cape Verde" },
    { symbol: "CW", name: "Curaçao" },
    { symbol: "CX", name: "Christmas Island" },
    { symbol: "CY", name: "Cyprus" },
    { symbol: "CZ", name: "Czechia" },
    { symbol: "DE", name: "Germany" },
    { symbol: "DJ", name: "Djibouti" },
    { symbol: "DK", name: "Denmark" },
    { symbol: "DM", name: "Dominica" },
    { symbol: "DO", name: "Dominican Republic" },
    { symbol: "DZ", name: "Algeria" },
    { symbol: "EC", name: "Ecuador" },
    { symbol: "EE", name: "Estonia" },
    { symbol: "EG", name: "Egypt" },
    { symbol: "EH", name: "Western Sahara" },
    { symbol: "ER", name: "Eritrea" },
    { symbol: "ES", name: "Spain" },
    { symbol: "ET", name: "Ethiopia" },
    { symbol: "FI", name: "Finland" },
    { symbol: "FJ", name: "Fiji" },
    { symbol: "FK", name: "Falkland Islands" },
    { symbol: "FO", name: "Faroe Islands" },
    { symbol: "FR", name: "France" },
    { symbol: "GA", name: "Gabon" },
    { symbol: "GB", name: "United Kingdom" },
    { symbol: "GD", name: "Grenada" },
    { symbol: "GE", name: "Georgia" },
    { symbol: "GF", name: "French Guiana" },
    { symbol: "GG", name: "Guernsey" },
    { symbol: "GH", name: "Ghana" },
    { symbol: "GI", name: "Gibraltar" },
    { symbol: "GL", name: "Greenland" },
    { symbol: "GM", name: "Gambia" },
    { symbol: "GN", name: "Guinea" },
    { symbol: "GP", name: "Guadeloupe" },
    { symbol: "GQ", name: "Equatorial Guinea" },
    { symbol: "GR", name: "Greece" },
    { symbol: "GS", name: "South Georgia & South Sandwich Islands" },
    { symbol: "GT", name: "Guatemala" },
    { symbol: "GW", name: "Guinea-Bissau" },
    { symbol: "GY", name: "Guyana" },
    { symbol: "HK", name: "Hong Kong SAR" },
    { symbol: "HM", name: "Heard & McDonald Islands" },
    { symbol: "HN", name: "Honduras" },
    { symbol: "HR", name: "Croatia" },
    { symbol: "HT", name: "Haiti" },
    { symbol: "HU", name: "Hungary" },
    { symbol: "ID", name: "Indonesia" },
    { symbol: "IE", name: "Ireland" },
    { symbol: "IL", name: "Israel" },
    { symbol: "IM", name: "Isle of Man" },
    { symbol: "IN", name: "India" },
    { symbol: "IO", name: "British Indian Ocean Territory" },
    { symbol: "IQ", name: "Iraq" },
    { symbol: "IR", name: "Iran" },
    { symbol: "IS", name: "Iceland" },
    { symbol: "IT", name: "Italy" },
    { symbol: "JE", name: "Jersey" },
    { symbol: "JM", name: "Jamaica" },
    { symbol: "JO", name: "Jordan" },
    { symbol: "JP", name: "Japan" },
    { symbol: "KE", name: "Kenya" },
    { symbol: "KG", name: "Kyrgyzstan" },
    { symbol: "KH", name: "Cambodia" },
    { symbol: "KI", name: "Kiribati" },
    { symbol: "KM", name: "Comoros" },
    { symbol: "KN", name: "St. Kitts & Nevis" },
    { symbol: "KP", name: "North Korea" },
    { symbol: "KR", name: "South Korea" },
    { symbol: "KW", name: "Kuwait" },
    { symbol: "KY", name: "Cayman Islands" },
    { symbol: "KZ", name: "Kazakhstan" },
    { symbol: "LA", name: "Laos" },
    { symbol: "LB", name: "Lebanon" },
    { symbol: "LC", name: "St. Lucia" },
    { symbol: "LI", name: "Liechtenstein" },
    { symbol: "LK", name: "Sri Lanka" },
    { symbol: "LR", name: "Liberia" },
    { symbol: "LS", name: "Lesotho" },
    { symbol: "LT", name: "Lithuania" },
    { symbol: "LU", name: "Luxembourg" },
    { symbol: "LV", name: "Latvia" },
    { symbol: "LY", name: "Libya" },
    { symbol: "MA", name: "Morocco" },
    { symbol: "MC", name: "Monaco" },
    { symbol: "MD", name: "Moldova" },
    { symbol: "ME", name: "Montenegro" },
    { symbol: "MF", name: "St. Martin" },
    { symbol: "MG", name: "Madagascar" },
    { symbol: "MK", name: "North Macedonia" },
    { symbol: "ML", name: "Mali" },
    { symbol: "MM", name: "Myanmar (Burma)" },
    { symbol: "MN", name: "Mongolia" },
    { symbol: "MO", name: "Macao SAR" },
    { symbol: "MQ", name: "Martinique" },
    { symbol: "MR", name: "Mauritania" },
    { symbol: "MS", name: "Montserrat" },
    { symbol: "MT", name: "Malta" },
    { symbol: "MU", name: "Mauritius" },
    { symbol: "MV", name: "Maldives" },
    { symbol: "MW", name: "Malawi" },
    { symbol: "MX", name: "Mexico" },
    { symbol: "MY", name: "Malaysia" },
    { symbol: "MZ", name: "Mozambique" },
    { symbol: "NA", name: "Namibia" },
    { symbol: "NC", name: "New Caledonia" },
    { symbol: "NE", name: "Niger" },
    { symbol: "NF", name: "Norfolk Island" },
    { symbol: "NG", name: "Nigeria" },
    { symbol: "NI", name: "Nicaragua" },
    { symbol: "NL", name: "Netherlands" },
    { symbol: "NO", name: "Norway" },
    { symbol: "NP", name: "Nepal" },
    { symbol: "NR", name: "Nauru" },
    { symbol: "NU", name: "Niue" },
    { symbol: "NZ", name: "New Zealand" },
    { symbol: "OM", name: "Oman" },
    { symbol: "PA", name: "Panama" },
    { symbol: "PE", name: "Peru" },
    { symbol: "PF", name: "French Polynesia" },
    { symbol: "PG", name: "Papua New Guinea" },
    { symbol: "PH", name: "Philippines" },
    { symbol: "PK", name: "Pakistan" },
    { symbol: "PL", name: "Poland" },
    { symbol: "PM", name: "St. Pierre & Miquelon" },
    { symbol: "PN", name: "Pitcairn Islands" },
    { symbol: "PS", name: "Palestinian Territories" },
    { symbol: "PT", name: "Portugal" },
    { symbol: "PY", name: "Paraguay" },
    { symbol: "QA", name: "Qatar" },
    { symbol: "RE", name: "Réunion" },
    { symbol: "RO", name: "Romania" },
    { symbol: "RS", name: "Serbia" },
    { symbol: "RU", name: "Russia" },
    { symbol: "RW", name: "Rwanda" },
    { symbol: "SA", name: "Saudi Arabia" },
    { symbol: "SB", name: "Solomon Islands" },
    { symbol: "SC", name: "Seychelles" },
    { symbol: "SD", name: "Sudan" },
    { symbol: "SE", name: "Sweden" },
    { symbol: "SG", name: "Singapore" },
    { symbol: "SH", name: "St. Helena" },
    { symbol: "SI", name: "Slovenia" },
    { symbol: "SJ", name: "Svalbard & Jan Mayen" },
    { symbol: "SK", name: "Slovakia" },
    { symbol: "SL", name: "Sierra Leone" },
    { symbol: "SM", name: "San Marino" },
    { symbol: "SN", name: "Senegal" },
    { symbol: "SO", name: "Somalia" },
    { symbol: "SR", name: "Suriname" },
    { symbol: "SS", name: "South Sudan" },
    { symbol: "ST", name: "São Tomé & Príncipe" },
    { symbol: "SV", name: "El Salvador" },
    { symbol: "SX", name: "Sint Maarten" },
    { symbol: "SY", name: "Syria" },
    { symbol: "SZ", name: "Eswatini" },
    { symbol: "TA", name: "Tristan da Cunha" },
    { symbol: "TC", name: "Turks & Caicos Islands" },
    { symbol: "TD", name: "Chad" },
    { symbol: "TF", name: "French Southern Territories" },
    { symbol: "TG", name: "Togo" },
    { symbol: "TH", name: "Thailand" },
    { symbol: "TJ", name: "Tajikistan" },
    { symbol: "TK", name: "Tokelau" },
    { symbol: "TL", name: "Timor-Leste" },
    { symbol: "TM", name: "Turkmenistan" },
    { symbol: "TN", name: "Tunisia" },
    { symbol: "TO", name: "Tonga" },
    { symbol: "TR", name: "Türkiye" },
    { symbol: "TT", name: "Trinidad & Tobago" },
    { symbol: "TV", name: "Tuvalu" },
    { symbol: "TW", name: "Taiwan" },
    { symbol: "TZ", name: "Tanzania" },
    { symbol: "UA", name: "Ukraine" },
    { symbol: "UG", name: "Uganda" },
    { symbol: "UM", name: "U.S. Outlying Islands" },
    { symbol: "US", name: "United States" },
    { symbol: "UY", name: "Uruguay" },
    { symbol: "UZ", name: "Uzbekistan" },
    { symbol: "VA", name: "Vatican City" },
    { symbol: "VC", name: "St. Vincent & Grenadines" },
    { symbol: "VE", name: "Venezuela" },
    { symbol: "VG", name: "British Virgin Islands" },
    { symbol: "VN", name: "Vietnam" },
    { symbol: "VU", name: "Vanuatu" },
    { symbol: "WF", name: "Wallis & Futuna" },
    { symbol: "WS", name: "Samoa" },
    { symbol: "XK", name: "Kosovo" },
    { symbol: "YE", name: "Yemen" },
    { symbol: "YT", name: "Mayotte" },
    { symbol: "ZA", name: "South Africa" },
    { symbol: "ZM", name: "Zambia" },
    { symbol: "ZW", name: "Zimbabwe" },
    { symbol: "ZZ", name: "Unknown Region" },
];

export const ALL_COLOR_HEX_MAP: Record<string, string> = {
    Red: "#FF0000",
    Blue: "#0000FF",
    Green: "#008000",
    Yellow: "#FFFF00",
    Orange: "#FFA500",
    Purple: "#800080",
    Pink: "#FFC0CB",
    Brown: "#A52A2A",
    Black: "#000000",
    White: "#FFFFFF",
    Gray: "#808080",
    Cyan: "#00FFFF",
    Magenta: "#FF00FF",
    Lime: "#00FF00",
    Olive: "#808000",
    Teal: "#008080",
    Navy: "#000080",
    Maroon: "#800000",
    Silver: "#C0C0C0",
    Gold: "#FFD700",
    Beige: "#F5F5DC",
    Coral: "#FF7F50",
    Crimson: "#DC143C",
    Indigo: "#4B0082",
    Ivory: "#FFFFF0",
    Khaki: "#F0E68C",
    Lavender: "#E6E6FA",
    Mint: "#98FF98",
    Orchid: "#DA70D6",
    Peach: "#FFE5B4",
    Plum: "#DDA0DD",
    Salmon: "#FA8072",
    Tan: "#D2B48C",
    Turquoise: "#40E0D0",
    Violet: "#EE82EE",
    Azure: "#F0FFFF",
    Bisque: "#FFE4C4",
    BlanchedAlmond: "#FFEBCD",
    BlueViolet: "#8A2BE2",
    BurlyWood: "#DEB887",
    CadetBlue: "#5F9EA0",
    Chartreuse: "#7FFF00",
    Chocolate: "#D2691E",
    CornflowerBlue: "#6495ED",
    Cornsilk: "#FFF8DC",
    DarkBlue: "#00008B",
    DarkCyan: "#008B8B",
    DarkGoldenRod: "#B8860B",
    DarkGray: "#A9A9A9",
    DarkGreen: "#006400",
    DarkKhaki: "#BDB76B",
    DarkMagenta: "#8B008B",
    DarkOliveGreen: "#556B2F",
    DarkOrange: "#FF8C00",
    DarkOrchid: "#9932CC",
    DarkRed: "#8B0000",
    DarkSalmon: "#E9967A",
    DarkSeaGreen: "#8FBC8F",
    DarkSlateBlue: "#483D8B",
    DarkSlateGray: "#2F4F4F",
    DarkTurquoise: "#00CED1",
    DarkViolet: "#9400D3",
    DeepPink: "#FF1493",
    DeepSkyBlue: "#00BFFF",
    DimGray: "#696969",
    DodgerBlue: "#1E90FF",
    FireBrick: "#B22222",
    FloralWhite: "#FFFAF0",
    ForestGreen: "#228B22",
    Gainsboro: "#DCDCDC",
    GhostWhite: "#F8F8FF",
    GoldenRod: "#DAA520",
    GreenYellow: "#ADFF2F",
    HoneyDew: "#F0FFF0",
    HotPink: "#FF69B4",
    IndianRed: "#CD5C5C",
    LawnGreen: "#7CFC00",
    LemonChiffon: "#FFFACD",
    LightBlue: "#ADD8E6",
    LightCoral: "#F08080",
    LightCyan: "#E0FFFF",
    LightGoldenRodYellow: "#FAFAD2",
    LightGray: "#D3D3D3",
    LightGreen: "#90EE90",
    LightPink: "#FFB6C1",
    LightSalmon: "#FFA07A",
    LightSeaGreen: "#20B2AA",
    LightSkyBlue: "#87CEFA",
    LightSlateGray: "#778899",
    LightSteelBlue: "#B0C4DE",
    LightYellow: "#FFFFE0",
    LimeGreen: "#32CD32",
    MediumAquaMarine: "#66CDAA",
    MediumBlue: "#0000CD",
    MediumOrchid: "#BA55D3",
    MediumPurple: "#9370DB",
    MediumSeaGreen: "#3CB371",
    MediumSlateBlue: "#7B68EE",
    MediumSpringGreen: "#00FA9A",
    MediumTurquoise: "#48D1CC",
    MediumVioletRed: "#C71585",
    MidnightBlue: "#191970",
    MistyRose: "#FFE4E1",
    Moccasin: "#FFE4B5",
    NavajoWhite: "#FFDEAD",
    OldLace: "#FDF5E6",
    OliveDrab: "#6B8E23",
    OrangeRed: "#FF4500",
    PaleGoldenRod: "#EEE8AA",
    PaleGreen: "#98FB98",
    PaleTurquoise: "#AFEEEE",
    PaleVioletRed: "#DB7093",
    PapayaWhip: "#FFEFD5",
    Peru: "#CD853F",
    PowderBlue: "#B0E0E6",
    RebeccaPurple: "#663399",
    RosyBrown: "#BC8F8F",
    RoyalBlue: "#4169E1",
    SaddleBrown: "#8B4513",
    SandyBrown: "#F4A460",
    SeaGreen: "#2E8B57",
    SeaShell: "#FFF5EE",
    Sienna: "#A0522D",
    SkyBlue: "#87CEEB",
    SlateBlue: "#6A5ACD",
    SlateGray: "#708090",
    Snow: "#FFFAFA",
    SpringGreen: "#00FF7F",
    SteelBlue: "#4682B4",
    Thistle: "#D8BFD8",
    Tomato: "#FF6347",
    Wheat: "#F5DEB3",
    WhiteSmoke: "#F5F5F5",
    YellowGreen: "#9ACD32",
    Charcoal: "#36454F",
    Eggplant: "#614051",
    MossGreen: "#8A9A5B",
    ParrotGreen: "#09B84D",
    BurntOrange: "#CC5500",
    DustyRose: "#C48189",
    Emerald: "#50C878",
    Flame: "#E25822",
    Fuchsia: "#FF00FF",
    Jade: "#00A86B",
    Ruby: "#E0115F",
    Sapphire: "#0F52BA",
    Scarlet: "#FF2400",
    Sepia: "#704214",
    SunsetOrange: "#FD5E53",
    Topaz: "#FFC87C",
    Amethyst: "#9966CC",
    Amber: "#FFBF00",
    BrickRed: "#CB4154",
    Caramel: "#FFDDA0",
    Champagne: "#F7E7CE",
    Cinnamon: "#D2691E",
    Cobalt: "#0047AB",
    Copper: "#B87333",
    Cream: "#FFFDD0",
    Denim: "#1560BD",
    Ebony: "#555D50",
    Feldspar: "#D19275",
    Granite: "#676767",
    JungleGreen: "#29AB87",
    Mahogany: "#C04000",
    Mulberry: "#C54B8C",
    Onyx: "#353839",
    PeacockBlue: "#1D5C63",
    Pear: "#D1E231",
    Quartz: "#51484F",
    Raspberry: "#E30B5C",
    Rust: "#B7410E",
    Sand: "#C2B280",
    SmokyBlack: "#100C08",
    Straw: "#E4D96F",
    Tangerine: "#F28500",
    TiffanyBlue: "#0ABAB5",
    Vanilla: "#F3E5AB",
    Wine: "#722F37",
    Zaffre: "#0014A8",
};

export const marketsArray = [{ value: "" }];

export const getCookie = (name: string): string | null => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift() ?? null;
    return null;
};

export const getCookieWithExpiry = (name: string): string | null => {
    const cookieValue = getCookie(name);
    if (!cookieValue) return null;

    // Assuming the cookie format is "value;expires=expiryDate"
    const parts = cookieValue.split(";");
    const value = parts[0];
    const expiresPart = parts.find((part) => part.trim().startsWith("expires="));

    if (!expiresPart) return value; // Return the value if no expiry date is present

    const expiryDate = new Date(expiresPart.split("=")[1]);
    const now = new Date();

    if (now < expiryDate) {
        return value; // Return the value if the cookie has not expired
    } else {
        // Optionally remove the expired cookie
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        return null; // Cookie has expired
    }
};

export function shouldShowPopupSession(key = "") {
    if (!key) {
        return false;
    }
    const popupShown = sessionStorage.getItem(key);
    if (!popupShown || popupShown == "false") {
        sessionStorage.setItem(key, "true"); // Mark popup as shown for this session
        return true; // Show the popup
    }
    return false; // Do not show the popup
}

export const hasNonDropdownOptions = (metafield: any): boolean => {
    if (!metafield?.value) return false;
    try {
        const parsed = JSON.parse(metafield.value);
        const options = parsed?.options || [];
        return options.some((o: any) => o.displayType !== "dropdown");
    } catch {
        return false;
    }
};

export const getDefaultColorByOptionValue = (value: string): string => {
    if (!value) return "#cccccc"; // fallback

    const normalizedValue = value.trim().toLowerCase().replace(/\s+/g, "");

    // try exact match
    const exactKey = Object.keys(ALL_COLOR_HEX_MAP).find(
        (key) => key.toLowerCase().replace(/\s+/g, "") === normalizedValue,
    );
    if (exactKey) return ALL_COLOR_HEX_MAP[exactKey];

    // try partial match (e.g., fallback to "Pink" in "Light Pink")
    const fallbackKey = Object.keys(ALL_COLOR_HEX_MAP).find((key) =>
        normalizedValue.includes(key.toLowerCase().replace(/\s+/g, "")),
    );
    if (fallbackKey) return ALL_COLOR_HEX_MAP[fallbackKey];

    return "#cccccc"; // final fallback
};

export const getNumberFieldSuffix = (
    discountType: string,
    moneyFormatOrCurrency: string,
    useCurrencySymbols: boolean = false,
) => {
    if (!discountType) return { show: false, suffix: "" };

    switch (discountType) {
        case "percentage":
            return { show: true, suffix: "%" };
        case "fixed":
        case "flat":
            return {
                show: true,
                suffix: useCurrencySymbols ? (useCurrencySymbols ?? "") : moneyFormatOrCurrency.split("{{")[0].trim(),
            };
        default:
            return { show: false, suffix: "" };
    }
};

export const getConditionMessage = (
    basis: "items_count" | "bundle_total",
    condition: "max_products" | "min_products" | "exact_products",
    subStep: boolean = false,
): string => {
    let messages = {
        items_count: {
            max_products: "Select up to {productCount} products",
            exact_products: "Select exactly {productCount} products",
            min_products: "Select at least {productCount} products",
        },
        bundle_total: {
            max_products: "Spend up to {amount}",
            exact_products: "Spend exactly {amount}",
            min_products: "Spend at least {amount}",
        },
    };
    if (subStep) {
        messages = {
            items_count: {
                max_products: "{category_label}: Select up to {productCount} products",
                exact_products: "{category_label}: Select exactly {productCount} products",
                min_products: "{category_label}: Select at least {productCount} products",
            },
            bundle_total: {
                max_products: "{category_label}: Spend up to {amount}",
                exact_products: "{category_label}: Spend exactly {amount}",
                min_products: "{category_label}: Spend at least {amount}",
            },
        };
    }

    return messages[basis][condition];
};

export const StoresWithSwatches = [
    "typsy-beauty.myshopify.com",
    "djhvdjh.myshopify.com",
    "newstoreetesttt.myshopify.com",
    "kefi-dev.myshopify.com",
    "kefi-aditya.myshopify.com",
];

//TODO: update with actual user account url
export const KINNBABY_SHOP_URL = [
    "new-kefi-aditya-2.myshopify.com",
    "kiin-baby.myshopify.com",
    "hjgebrn.myshopify.com",
    "hellowstore13.myshopify.com"]; // kiinbaby.myshopify.com
